// //TODO: What about multi-tran support??
// //TODO: Refine how "process" method of dataservice works?    Should it handle the ConceptOneRequest and Transaction Layers???

// //TODO:  !!!!!!!!!Should we handle the "cr.@" prefixing for dbquery parameters in the Data service (or httpget) 
// rather than in the critieria node.   This would make code more straight forward!!!!!

// //TODO: Move credentials to local storage rather than keeping in this service???

import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { Observable, throwError } from 'rxjs';
import { SessionStorage } from '@Core/services/proprietary/browser-storage/session-storage.service';
import { environment } from 'src/environments/environment';
import { AppConfigService } from './app-config.service';
import { DataSourceStatus, Datasource } from './datasource';
import { ErrorService } from './error.service';

@Injectable()
export class DatasourceService {
    private isSaaS: boolean;
    private readonly sureMgaGuid = 'CE82B2FB-8C32-445C-B70D-EF721DC56185';

    constructor(
        private httpClient: HttpClient,
        private appConfig: AppConfigService,
        private errorService: ErrorService,
        private sessionStorage: SessionStorage
    ) {
        this.isSaaS = environment.SaaS;
    }

    // TODO WRG SECURE API
    //authorization = '';
    ETMSystemOverride: string = '';

    startRefreshInterval(ds: Datasource, value: number) {
        const isPaused = ds._paused;
        if (!isPaused) {
            ds.refreshInterval = value;
        }

        if (ds._intervalID) {
            clearInterval(ds._intervalID);
            ds._intervalID = null;
        }

        if (!isPaused && ds._refreshInterval > 0) {
            ds._intervalID = setInterval(() => {
                this.refresh(ds);
            }, ds._refreshInterval * 1000);
        }
    }

    //TODO should there be separate function for Get, Collection, Template or should you set the component to a type of transaction for get? 
    // Refresh would only apply to Get and Collection.

    reset(ds: Datasource): Observable<any> {
        ds._dataLocation = '';
        ds.data = JSON.parse('{}');
        ds._replyCode = 0;
        ds._replyMessage = '';
        ds.setStatus(DataSourceStatus.Initialized);
        ds.blobSize = 0;
        ds.blob = null;
        if (ds.blobURL) {
            // destroy url to previous doc
            URL.revokeObjectURL(ds.blobURL);
            ds.blobURL = null;
        }
        return ds.data;
    }

    cacheFlushAll() {
        this.sessionStorage.removeItemOfType('datacache:');
    }

    async cacheFlushStale() {
        const datacacheKeys = this.sessionStorage.getAllKeys().filter((key) => key.indexOf('datacache:') > -1);
        let nowTS = moment.now();
        for (const key of datacacheKeys) {
            let cachedValue = await this.sessionStorage.getItemAsync(key);
            if (cachedValue) {
                try {
                    let data = JSON.parse(cachedValue);
                    let cacheTS = data.Local_Cache_Expiration_TS * 1;
                    if (cacheTS < nowTS) {
                        this.sessionStorage.removeItem(key);
                    }
                } catch (e) {
                    console.log(`Datasource Service cacheFlushStale parsing retrieved storage value errored for ${key}`);
                }
            }
        }
    }

    cacheFlushTranType(tranType: string) {
        let prefix = 'datacache:' + tranType.toLocaleLowerCase();
        const tranTypeKeys = this.sessionStorage.getAllKeys().filter((key) => key.indexOf(prefix) > -1);

        for (const key of tranTypeKeys) {
            this.sessionStorage.removeItem(key);
        }
    }

    cacheFlushObjectType(objectCode: string) {
        this.cacheFlushTranType(objectCode + 'Collection');
        this.cacheFlushTranType(objectCode + 'Get');
        this.cacheFlushTranType(objectCode + 'Template');
    }

    async cacheSave(ds: Datasource) {
        if (this.appConfig.allowDataCache && ds.cacheLifeSpan > 0 && ds._refreshTranClass != 'Template') {
            let sig = ds.cacheSignature;
            ds.data.Local_Cache_Expiration_TS = (moment.now() + +ds.cacheLifeSpan * 1000).toString();
            let stringifiedData = JSON.stringify(ds.data);
            try {
                await this.sessionStorage.setItemAsync(sig, stringifiedData);
            } catch (e) {
                this.cacheFlushStale();
                try {
                    await this.sessionStorage.setItemAsync(sig, stringifiedData);
                } catch (e) {
                    this.cacheFlushAll();
                    await this.sessionStorage.setItemAsync(sig, stringifiedData);
                }
            }
        }
    }

    async cacheDelete(ds: Datasource): Promise<boolean> {
        return new Promise(async (resolve, reject) => {
            if (this.appConfig.allowDataCache && ds.cacheLifeSpan > 0) {
                let sig = ds.cacheSignature;
                const deleteStatus = await this.sessionStorage.removeItemAsync(sig);
                resolve(deleteStatus);
            } else {
                resolve(false);
            }
        });
    }

    async cacheGet(ds: Datasource): Promise<string | null> {
        return new Promise(async (resolve, reject) => {
            if (this.appConfig.allowDataCache && ds.cacheLifeSpan > 0) {
                let sig = ds.cacheSignature;
                let cachedValue = await this.sessionStorage.getItemAsync(sig);
                if (cachedValue !== null) {
                    let data = JSON.parse(cachedValue);
                    let cacheTS = data.Local_Cache_Expiration_TS * 1;
                    let nowTS = moment.now();
                    if (cacheTS >= nowTS) {
                        // cache is not stale
                        if (ds._subscription) {
                            ds._subscription.unsubscribe();
                        }
                        ds._dataLocation = 'LocalCache';
                        ds.data = data;
                        ds._httpResponseCode = 200;
                        ds.setReplyCode(200, 'OK');
                        resolve('Cache Not Stale');
                    } else {
                        resolve('Cache Is Stale');
                    }
                } else {
                    resolve('Cached value was null');
                }
            } else {
                resolve('Item was not cached');
            }
        });
    }

    async refresh(ds: Datasource, useCache: boolean = true) {
        if (!ds._objectType) {
            ds._replyCode = -1;
            ds._replyMessage = '';
            ds.setStatus(DataSourceStatus.InvalidConfig);
            return;
        }

        if (ds._objectType == 'MockData') {
            //no refresh needed
            return;
        }

        if (ds._datasourceType == 'Base') {
            ds._replyCode = -1;
            ds._replyMessage = "'Refresh' is not valid for a 'Base' datasource type.";
            return;
        }

        var uri: string;

        switch (
        ds._refreshTranClass //TODO, put this is a json object and do a lookup instead?
        ) {
            case 'Get':
                uri = this.buildUri(ds, ds._tranGetUriPath, ds._tranGetDefaultView, ds._criteria);
                break;
            case 'Collection':
                uri = this.buildUri(ds, ds._tranCollectionUriPath, ds._tranCollectionDefaultView, ds._criteria);
                break;
            default:
                ds._replyMessage = 'Refresh not supported for ' + ds._refreshTranClass;
                ds._replyCode = -1;
                ds.setStatus(DataSourceStatus.Error);
                return;
        }

        ds._dataLocation = 'Server';
        ds._replyCode = 0;
        ds._replyMessage = '';
        ds.setStatus(DataSourceStatus.Loading);

        if (useCache) {
            const fromCache = await this.cacheGet(ds);
            if (fromCache == 'Cache Not Stale') {
                return;
            }
        }

        const deleteCache = this.cacheDelete(ds);
        deleteCache.then((deleteCacheStatus) => {
            this.refreshData(ds, uri);
        });
    }

    refreshData(ds: Datasource, uri: string) {
        if (ds._subscription) {
            ds._subscription.unsubscribe();
        }
        ds._subscription = this.httpGet(ds, uri).subscribe(
            (res) => {
                this.extractReplyData(ds, res);
            },
            (error) => {
                this.extractErrorData(ds, error);
            }
        );
    }

    async get(ds: Datasource, criteria: any, retrieveNow: boolean = true, useCache: boolean = true) {
        if (ds._datasourceType == 'Base') {
            ds._replyCode = -1;
            ds._replyMessage = "'Get' is not valid for a 'Base' datasource type.";
            return;
        }

        ds._criteria = criteria;
        ds._tranType = ds._objectType + 'Get';
        if (ds._objectType.toLowerCase() == 'dbquery') {
            ds._tranType = ds._objectType + 'Process';
        }
        if (ds._objectType.toLowerCase() == 'authenticate') {
            ds._tranType = ds._objectType;
        }
        ds._refreshTranClass = 'Get';

        if (!ds._objectType) {
            ds._replyCode = -1;
            ds._replyMessage = '';
            ds.setStatus(DataSourceStatus.InvalidConfig);
            return;
        }

        if (!ds._tranGetUriPath) {
            ds._replyCode = -1;
            ds._replyMessage = '';
            ds.setStatus(DataSourceStatus.InvalidConfig);
            return;
        }

        let uri = this.buildUri(ds, ds._tranGetUriPath, ds._tranGetDefaultView, criteria);

        ds._replyCode = 0;
        ds._replyMessage = '';

        if (retrieveNow) {
            ds.setStatus(DataSourceStatus.Loading);

            if (useCache) {
                const fromCache = await this.cacheGet(ds);
                if (fromCache == 'Cache Not Stale') {
                    return;
                }
            }

            const deleteCache = this.cacheDelete(ds);
            deleteCache.then((deleteCacheStatus) => {
                this.refreshData(ds, uri);
            });
        }
    }

    async getCollection(ds: Datasource, criteria: any, retrieveNow: boolean = true, useCache: boolean = true) {
        if (ds._datasourceType == 'Base') {
            ds._replyCode = -1;
            ds._replyMessage = "'GetCollection' is not valid for a 'Base' datasource type.";
            return;
        }

        if (ds.maxRowLimiter && ds.maxRows > 0) {
            criteria.Max = ds.maxRows;
        }

        ds._criteria = criteria;
        ds._tranType = ds._objectType + 'Collection';
        if (ds._objectType.toLowerCase() == 'dbquery') {
            ds._tranType = ds._objectType + 'Process';
            // TODO:  Max not yet supported in DBQuery.   We need to conditionally support in SDK (ignore if proc does not have parameter)
            delete criteria.Max;
        }
        ds._refreshTranClass = 'Collection';

        if (!ds._objectType) {
            ds._replyCode = -1;
            ds._replyMessage = '';
            ds.setStatus(DataSourceStatus.InvalidConfig);
            return;
        }

        if (!ds._tranCollectionUriPath) {
            ds._replyCode = -1;
            ds._replyMessage = '';
            ds.setStatus(DataSourceStatus.InvalidConfig);
            return;
        }

        let uri = this.buildUri(ds, ds._tranCollectionUriPath, ds._tranCollectionDefaultView, criteria);

        ds._replyCode = 0;
        ds._replyMessage = '';

        if (retrieveNow) {
            ds.setStatus(DataSourceStatus.Loading);

            if (useCache) {
                const fromCache = await this.cacheGet(ds);
                if (fromCache == 'Cache Not Stale') {
                    return;
                }
            }

            const deleteCache = this.cacheDelete(ds);
            deleteCache.then((deleteCacheStatus) => {
                this.refreshData(ds, uri);
            });
        }
    }

    getTemplate(ds: Datasource, criteria: any, retrieveNow: boolean = true) {
        if (ds._datasourceType == 'Base') {
            ds._replyCode = -1;
            ds._replyMessage = "'GetTemplate' is not valid for a 'Base' datasource type.";
            return;
        }

        ds._criteria = criteria;
        ds._tranType = ds._objectType + 'Template';
        ds._refreshTranClass = 'Template';

        if (!ds._objectType) {
            ds._replyCode = -1;
            ds._replyMessage = '';
            ds.setStatus(DataSourceStatus.InvalidConfig);
            return;
        }

        if (!ds._tranTemplateUriPath) {
            ds._replyCode = -1;
            ds._replyMessage = '';
            ds.setStatus(DataSourceStatus.InvalidConfig);
            return;
        }

        let uri = this.buildUri(ds, ds._tranTemplateUriPath, ds._tranTemplateDefaultView, criteria);

        ds._replyCode = 0;
        ds._replyMessage = '';

        if (retrieveNow) {
            ds._dataLocation = 'Server';
            ds.setStatus(DataSourceStatus.Loading);

            if (ds._subscription) {
                ds._subscription.unsubscribe();
            }

            ds._subscription = this.httpGet(ds, uri).subscribe(
                (res) => {
                    this.extractReplyData(ds, res);
                },
                (error) => {
                    this.extractErrorData(ds, error);
                }
            );
        }
    }

    //TODO: Refine how "process" method of dataservice works?    Should it handle the ConceptOneRequest and Transaction Layers???
    async process(ds: Datasource, criteria: any, body: any) {
        if (ds._datasourceType == 'Base') {
            ds._replyCode = -1;
            ds._replyMessage = "'post' is not valid for a 'Base' datasource type.";
            return;
        }

        ds._criteria = criteria;

        ds._tranType = ds._objectType + 'Process';
        ds._refreshTranClass = 'Process';

        if (!ds._objectType) {
            ds._replyCode = -1;
            ds._replyMessage = '';
            ds.setStatus(DataSourceStatus.InvalidConfig);
            return;
        }

        if (!ds._tranProcessUriPath) {
            ds._replyCode = -1;
            ds._replyMessage = '';
            ds.setStatus(DataSourceStatus.InvalidConfig);
            return;
        }

        let uri = this.buildUri(ds, ds._tranProcessUriPath, 'Full', criteria);

        ds._dataLocation = 'Server';
        ds._replyCode = 0;
        ds._replyMessage = '';
        ds.setStatus(DataSourceStatus.Loading);

        this.httpPost(ds, uri, body).subscribe(
            (res) => {
                this.cacheFlushObjectType(ds._objectType);
                this.extractReplyData(ds, res);
            },
            (error) => {
                this.extractErrorData(ds, error);
            }
        );
    }

    async patch(ds: Datasource, criteria: any, body: any) {
        if (!environment.SaaS) {
            ds._replyCode = -1;
            ds._replyMessage = "'patch' is only valid in a SaaS environment.";
            return;
        }

        if (ds._datasourceType == 'Base') {
            ds._replyCode = -1;
            ds._replyMessage = "'patch' is not valid for a 'Base' datasource type.";
            return;
        }

        ds._criteria = criteria;

        ds._tranType = ds._objectType + 'Process';
        ds._refreshTranClass = 'Process';

        if (!ds._objectType) {
            ds._replyCode = -1;
            ds._replyMessage = '';
            ds.setStatus(DataSourceStatus.InvalidConfig);
            return;
        }

        if (!ds._tranPatchUriPath) {
            ds._replyCode = -1;
            ds._replyMessage = '';
            ds.setStatus(DataSourceStatus.InvalidConfig);
            return;
        }

        let uri = this.buildUri(ds, ds._tranPatchUriPath, 'Full', criteria);

        ds._dataLocation = 'Server';
        ds._replyCode = 0;
        ds._replyMessage = '';
        ds.setStatus(DataSourceStatus.Loading);

        this.httpPatch(ds, uri, body).subscribe(
            (res) => {
                this.cacheFlushObjectType(ds._objectType);
                this.extractReplyData(ds, res);
            },
            (error) => {
                this.extractErrorData(ds, error);
            }
        );
    }

    extractReplyData(ds: Datasource, res: HttpResponse<any>) {
        let blobMode = false;
        let replyContentType = res.headers.get('content-type') || 'application/json';
        replyContentType = replyContentType.split(';')[0];

        switch (replyContentType.toLowerCase()) {
            case 'application/pdf':
                if (!res.body.Content || res.body.Content.size <= 0) {
                    ds.data = res.body || {};
                } else {
                    blobMode = true;
                    ds.blobSize = res.body.Content.size;
                    let newBlobURL = URL.createObjectURL(res.body.Content); //create in memory filestream
                    if (ds.blobURL) {
                        URL.revokeObjectURL(ds.blobURL);
                    } // destroy url to previous doc
                    ds.blobURL = newBlobURL;
                    ds.blob = res.body.Content;
                    ds.data = { Blob_URL: ds.blobURL, Blob_Size: ds.blobSize, blob: res.body.Content };
                }
                break;
            case 'application/json':
                ds.data = res.body.Content || {};
                break;
            case 'application/vnd.api+json':
                ds.data = res.body.Content || {};
                break;
            case 'application/xml':
                ds.data = { XML: res.body.Content || '' };
                break;
            default:
                console.log('unsupported reply type: ' + replyContentType);
                ds.data = { Unsupported_Content_Type: replyContentType };
        }

        if (!blobMode) {
            ds.blobSize = 0;
            if (ds.blobURL) {
                URL.revokeObjectURL(ds.blobURL);
            } // destroy url to previous doc
            ds.blobURL = null;
            ds.blob = null;
        }

        ds._httpResponseCode = 200;
        ds.setReplyCode(200, 'OK');
        ds.lastRequestUrl = res.url;
        this.cacheSave(ds);
        // Don't show error dialog if due to User Defined Validation (-5004) or for ZipCodeGet or for LockProcess.
        if (
            ds._replyCode &&
            +ds._replyCode < 0 &&
            +ds._replyCode != -5004 &&
            ds.showErrors &&
            ds._tranType != 'ZipCodeGet' &&
            ds._tranType != 'LockProcess' &&
            ds._tranType != 'SystemInfoGet' &&
            ds._tranType != 'PasswordProcess' &&
            ds._tranType != 'LockboxProcess' &&
            ds._tranType != 'SanctionLookupCollection' &&
            ds._tranType != 'EntitySanctionProcess' &&
            ds._tranType != 'EntitySanctionGet'
        ) {
            let dsError: any = {
                type: 'page',
                message: ''
            };
            this.errorService.showError(dsError, ds);
        }
    }

    extractErrorData(ds: Datasource, error: any) {
        // ds.data = {};
        ds.data = JSON.parse('{}');
        ds.blobSize = 0;
        ds.blob = null;
        if (ds.blobURL) {
            // destroy url to previous doc
            URL.revokeObjectURL(ds.blobURL);
            ds.blobURL = null;
        }
        ds._httpResponseCode = error.status;
        console.error('http error processing');
        console.error(error);
        ds.setReplyCode(error.status, error.statusText, DataSourceStatus.Error);
        ds.lastRequestUrl = error.url;
        // Don't show error dialog for 400 errors as they are being handled in http interceptor
        if (error.status !== 400) {
            let dsError: any = {
                type: 'page',
                message: error.message ? error.message : ''
            };
            this.errorService.showError(dsError, ds);
        }
    }

    private httpGet(ds: Datasource, uri: string): Observable<any> {
        if (!ds._objectType) {
            ds._replyCode = -1;
            ds._replyMessage = '';
            ds.setStatus(DataSourceStatus.InvalidConfig);
            return;
        }

        ds.setStatus(DataSourceStatus.Loading);

        var headers = new HttpHeaders({
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache',
            Expires: 'Sat, 01 Jan 2000 00:00:00 GMT'
        });

        if (
            (ds.criteria.Doc_ID && ds.criteria.Doc_ID.toLowerCase().endsWith('.pdf')) ||
            (ds._tranGetUriPath && ds._tranGetUriPath.toLowerCase().endsWith('.pdf'))
        ) {
            //if (environment.SaaS) {
            headers = headers.append('SureMGAID', this.sureMgaGuid);
            headers = headers.append('Accept', 'application/pdf');
            headers = headers.append('Ocp-Apim-Subscription-Key', environment.SubscriptionKey);
            //}

            return this.httpClient.get(uri, { observe: 'response', headers, responseType: 'blob' });
        } else {
            //if (environment.SaaS) {
            headers = headers.append('SureMGAID', this.sureMgaGuid);
            headers = headers.append('Ocp-Apim-Subscription-Key', environment.SubscriptionKey);
            switch (ds._apiType) {
                case 'XML':
                    headers = headers.append('Accept', 'application/json');
                    break;

                case 'JSON':
                    headers = headers.append('Accept', 'application/vnd.api+json');
                    break;
            }
            //}
            return this.httpClient.get(uri, { observe: 'response', headers });
        }
    }

    private httpPost(ds: Datasource, uri: string, body: any): Observable<any> {
        var headers = new HttpHeaders({});

        //if (environment.SaaS) {
        headers = headers.append('SureMGAID', this.sureMgaGuid);
        headers = headers.append('Ocp-Apim-Subscription-Key', environment.SubscriptionKey);

        switch (ds._apiType) {
            case 'XML':
                headers = headers.append('Content-Type', 'application/json');
                headers = headers.append('Accept', 'application/json');
                break;

            case 'JSON':
                headers = headers.append('Content-Type', 'application/vnd.api+json');
                headers = headers.append('Accept', 'application/vnd.api+json');
                break;
        }
        //}

        if (!ds._objectType) {
            ds._replyCode = -1;
            ds._replyMessage = '';
            ds.setStatus(DataSourceStatus.InvalidConfig);
            return;
        }

        ds.setStatus(DataSourceStatus.Loading);

        return this.httpClient.post(uri, body, { observe: 'response', headers });
    }

    private httpPatch(ds: Datasource, uri: string, body: any) {
        //if (environment.SaaS) {
        var headers = new HttpHeaders({});

        headers = headers.append('SureMGAID', this.sureMgaGuid);
        headers = headers.append('Ocp-Apim-Subscription-Key', environment.SubscriptionKey);
        switch (ds._apiType) {
            case 'XML':
                headers = headers.append('Accept', 'application/json');
                headers = headers.append('Content-Type', 'application/json');
                break;

            case 'JSON':
                headers = headers.append('Accept', 'application/vnd.api+json');
                headers = headers.append('Content-Type', 'application/vnd.api+json');
                break;
        }

        if (!ds._objectType) {
            ds._replyCode = -1;
            ds._replyMessage = '';
            ds.setStatus(DataSourceStatus.InvalidConfig);
            return;
        }

        ds.setStatus(DataSourceStatus.Loading);

        return this.httpClient.patch(uri, body, { observe: 'response', headers });
        //}
    }

    private buildUri(ds: Datasource, uriTemplate: string, defaultView: string, criteria: any): string {
        let uri = (this.isSaaS ? environment.ApiUrl : 'api/etm?Endpoint=') + uriTemplate.toLowerCase();
        let loc = 0;
        //uri = uri.toLowerCase();

        if (criteria['View']) {
        } else {
            criteria['View'] = defaultView;
        }

        let firstApiParm: boolean = false;
        if (this.isSaaS) {
            firstApiParm = true;
        }

        for (let key in criteria) {
            if (criteria.hasOwnProperty(key)) {
                let val = criteria[key];
                if (val) {
                    let token = '{' + key.toLowerCase() + '}';
                    loc = uri.indexOf(token);
                    if (loc >= 0) {
                        // if key name matches token in uri template then replace value
                        uri = uri.replace(token, encodeURIComponent(val));
                    } else {
                        // otherwise add the key and value to the query parameter list
                        if (ds.tranType != 'DBQueryProcess') {
                            uri = uri + (firstApiParm ? '?' : '&') + key + '=' + encodeURIComponent(criteria[key]);
                        } else {
                            //DBQuery
                            let lcKey = key.toLowerCase();
                            if (lcKey == 'view' || lcKey == 'procedure_name' || lcKey.startsWith('cr.@')) {
                                uri = uri + (firstApiParm ? '?' : '&') + key + '=' + encodeURIComponent(criteria[key]);
                            } else {
                                // add cr.@ prefix to retrival args  (if not already in criteria key name)
                                uri = uri + (firstApiParm ? '?' : '&') + 'cr.@' + key + '=' + encodeURIComponent(criteria[key]);
                            }
                        }
                        firstApiParm = false;
                    }
                }
            }
        }

        return uri;
    }

    private handleError(error: any) {
        // In a real world app, we might use a remote logging infrastructure
        // We'd also dig deeper into the error to get a better message

        let errMsg = error.message
            ? error.message
            : error.status
                ? `${error.status} - ${error.statusText}`
                : 'Server error';
        console.error(errMsg); // log to console instead

        if (error.status == 500 && error._body) {
            console.log(error._body);
        }

        let errStatusText = error.message ? error.message : error.status ? `${error.statusText}` : 'Server error';
        let errStatus = error.status ? `${error.status * -1}` : '-500'; //return http error codes as negatives

        return throwError({ status: errStatus, statusText: errStatusText });
    }
}
